import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { MatDialog } from '@angular/material/dialog';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { DialogClasificacionComponent } from '../dialog-clasificacion/dialog-clasificacion.component';
import { TemaService } from 'src/app/services/tema.services';
import { Subscription } from 'rxjs';
import { DialogExclusionComponent } from '../dialog-exclusion/dialog-exclusion.component';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { RastreadorService } from 'src/app/services/rastreador.service';
import { ListaVariacionInterface } from 'src/app/interface/ListaVariacionInterface';
import { companiaLista } from 'src/app/interface/CompaniaListaInterface';
import { CompaniaRastreadorInterface } from 'src/app/interface/CompaniaRastreadorInterface';
import { Suscripcion } from 'src/app/models/suscripcion';
import { VariationGroup } from 'src/app/interface/variationGroup';
import { InterfaceformdataRastreador } from 'src/app/services/rastreador.service';

@Component({
  selector: 'app-analisis-estadistico',
  templateUrl: './analisis-estadistico.component.html',
  styleUrl: './analisis-estadistico.component.scss'
})
export class AnalisisEstadisticoComponent implements OnInit, OnDestroy, OnChanges {

  public filaSeleccionada: any;
  public subLva: Subscription;
  public subLvn: Subscription;
  public arrayresultados: Subscription;
  public subCompania: Subscription;
  public lvnData: CdkTableVirtualScrollDataSource<ListaVariacionInterface>;
  public lvaData: CdkTableVirtualScrollDataSource<ListaVariacionInterface>;
  public originalDataLvn: ListaVariacionInterface[];
  public originalDataLva: ListaVariacionInterface[];
  public variacionMayorPositivo: number = 0;
  public variacionMenorPositivo: number = 0;
  public variacionMayorNegativo: number = 0;
  public variacionMenorNegativo: number = 0;
  public variacionMayorFF: number = 0;
  public variacionMenorFF: number = 0;
  public contadorperiodos: number = 0;
  public contadorVolatilidad: number = 0;
  public clasificacionporcentual: number = 0.25;
  @Input() selectedTab: number = 0;
    @Input() Modelformdata!: InterfaceformdataRastreador;
  @ViewChild('viewportPositivos') viewportPositivos: CdkVirtualScrollViewport;
  @ViewChild('viewportNegativos') viewportNegativos: CdkVirtualScrollViewport;

arrayPositivos: any[];
  arrayNegativos: any[];
  tableColumns: TableColmuns[] = [
    { id: 'idNectum', name: 'Id', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'descripcion', name: 'Periodos Positivos', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'cantidad', name: 'Cantidad', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'compania', name: 'Compañia', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'valorMenor', name: 'Valor Menor', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'valorMayor', name: 'Valor Mayor', isShow: false, isDate: false, isNumber: true, isString: false },
  ]
  tableColumns2: TableColmuns[] = [
    { id: 'idNectum', name: 'Id', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'descripcion', name: 'Periodos Negativos', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'cantidad', name: 'Cantidad', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'compania', name: 'Compañia', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'valorMenor', name: 'Valor Menor', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'valorMayor', name: 'Valor Mayor', isShow: false, isDate: false, isNumber: true, isString: false },
  ]

  displayedColumns: string[] = ['descripcion', 'cantidad',
    'compania'];
  subTema: Subscription;
  isDark: any;
  companiaSeleccionada: CompaniaRastreadorInterface = {
    idCompaniaLista: 0,
    nombre: '',
    descripcion: '',
    mercado: '',
    idMercado: 0,
    idNectum: 0,
    tipo: '',
    n: 0,
    fecha: '',
    proximo: '',
    dias: 0,
    timeProximo: '',
    timeActual: '',
    estado: false
  };

  constructor(public dialog: MatDialog,
    public temaService: TemaService,
    public _rastreadorSV: RastreadorService,
  ) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("DSDE ESTUDIO ANALISIS ESTADISTICO selectedTab:", this.selectedTab)
    if (this.selectedTab == 0) {

    }

  }

  ngOnInit() {
    this.subTema = this.temaService.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
      }
    });
    this.subLva = this._rastreadorSV.vallistaVariacion$.subscribe({
      next: (data: any) => {
        this.arrayPositivos = data;
        this.actualizarContadoresP(0);
        const groupedData = this.groupVariationsByRange(data, this.clasificacionporcentual, 1);
        this.lvaData = new CdkTableVirtualScrollDataSource(groupedData);
        this.actualizarViewports();
      }
    });
    this.subLvn = this._rastreadorSV.vallistaVariacionNegativa$.subscribe({
      next: (data: any) => {
        this.arrayNegativos = data;
        this.actualizarContadoresN(0);
        const groupedData = this.groupVariationsByRange(data, this.clasificacionporcentual, -1);
        this.lvnData = new CdkTableVirtualScrollDataSource(groupedData);
        this.actualizarViewports();
      }
    });
   

    this.subCompania = this._rastreadorSV.valCompaniaSelec$.subscribe({
      next: (data: any) => {
        if (data.idNectum != this.companiaSeleccionada.idNectum) {
          this.companiaSeleccionada = data;

          if (this.companiaSeleccionada.nombre) {
              this.companiaSeleccionada.nombre = this.companiaSeleccionada.nombre.replace(/^✔\s*/, '');
              this.actualizarContadoresN(this.companiaSeleccionada.idNectum);
              this.actualizarContadoresP(this.companiaSeleccionada.idNectum);
              // Si la compañía seleccionada no forma parte del análisis actual (p.ej. se
              // seleccionó en el panel "Compañías" para Estudio Earning, sin relación con
              // esta corrida de Estadísticas), no vaciar la tabla: se mantiene el detalle
              // completo en vez de filtrar a un conjunto vacío.
              const filtradosPositivos = (this.arrayPositivos ?? []).filter(item => item.idNectum === this.companiaSeleccionada.idNectum);
              if (filtradosPositivos.length > 0) {
                  const groupedData = this.groupVariationsByRange(filtradosPositivos, this.clasificacionporcentual, 1);
                  this.lvaData = new CdkTableVirtualScrollDataSource(groupedData);
              }
              const filtradosNegativos = (this.arrayNegativos ?? []).filter(item => item.idNectum === this.companiaSeleccionada.idNectum);
              if (filtradosNegativos.length > 0) {
                  const groupedDataN = this.groupVariationsByRange(filtradosNegativos, this.clasificacionporcentual, 1);
                  this.lvnData = new CdkTableVirtualScrollDataSource(groupedDataN);
              }
              this.actualizarViewports();
          }

        }

      }
    });

    //escuchar cambios en this.clasificacionporcentual 


  }

  groupVariationsByRange(data: any[], rangeInterval: number, positivos: number): ListaVariacionInterface[] {
    const groups: ListaVariacionInterface[] = [];
    if (data.length > 0) {
      let maxRange = 10;
      let minRange = 0;
      if (positivos == -1) {
        maxRange = 0;
        minRange = -10;
      }
      let companiaN = '';
      if(data[0].compania === data[data.length-1].compania)
        companiaN = data[0].compania;
      else
        companiaN = 'Todas';

      for (let i = minRange; i < maxRange; i += rangeInterval) {
        groups.push({
          descripcion: `ENTRE ${i.toFixed(2)} y ${(i + rangeInterval).toFixed(2)}`,
          cantidad: 0,
          items: [],
          valorMenor: 0,
          valorMayor: 0,
          idNectum: 0,
          compania: companiaN,
          valorMenorFechaFin: 0,
          valorMayorFechaFin: 0,
          periodosAnalizados: 0,
          periodosVolatilidad: 0
        });
      }

      // Group the data
      data.forEach(item => {
        const variation = Math.abs(item.variacion);
        const groupIndex = Math.min(Math.floor(variation / rangeInterval), groups.length - 1);

        if (groupIndex >= 0 && groupIndex < groups.length) {
          groups[groupIndex].cantidad++;
          groups[groupIndex].items.push(item);
        }
      });
    }

    //return groups.filter(group => group.count > 0);
    return groups;
  }

  rangoVariacionMenor(arrayNegativos: any[]) {
    
  }
  rangoVariacionMenorFF(arrayNegativos: any[]) {
    for (const item of arrayNegativos) {
      if (item.variacionFechaFin < -this.Modelformdata.rangoPorcentualEvaluar) {
        this.variacionMenorFF += 1;
      }
    }
  }
  actualizarContadoresP(idNectum: number) {
    this.variacionMayorPositivo = 0; // Reinicia el acumulador antes de comenzar
    this.variacionMenorPositivo = 0; // Reinicia el acumulador antes de comenzar
    this.variacionMayorFF = 0; // Reinicia el acumulador antes de comenzar
    let arrayTemporal = null;
    if(idNectum == 0)
      arrayTemporal = this.arrayPositivos;
    else{
      arrayTemporal = this.arrayPositivos.filter(item => item.idNectum === idNectum);
      console.log(arrayTemporal);
    }
    this.contadorperiodos = arrayTemporal.length;
    this.contadorVolatilidad = arrayTemporal.filter(item => item.existeVolatilidad).length;
      console.log("arrayTemporal", arrayTemporal.length + " idnectum " + idNectum); 
    for (const item of arrayTemporal) {
      if (item.variacion > this.Modelformdata.rangoPorcentualEvaluar) {
        this.variacionMayorPositivo += 1;
      }else if (item.variacion < this.Modelformdata.rangoPorcentualEvaluar) {
        this.variacionMenorPositivo += 1;
      }
      if (item.variacionFechaFin > this.Modelformdata.rangoPorcentualEvaluar) {
        this.variacionMayorFF += 1;
      }
    }

  }
  actualizarContadoresN(idNectum: number){
    this.variacionMenorFF = 0; // Reinicia el acumulador antes de comenzar
    this.variacionMenorNegativo = 0; // Reinicia el acumulador antes de comenzar
    this.variacionMayorNegativo = 0; // Reinicia el acumulador antes de comenzar
    let arrayTemporal = null;
    if(idNectum == 0)
      arrayTemporal = this.arrayNegativos;
    else
      arrayTemporal = this.arrayNegativos.filter(item => item.idNectum === idNectum);
    for (const item of arrayTemporal) {
      if (item.variacion < -this.Modelformdata.rangoPorcentualEvaluar) {
        this.variacionMenorNegativo += 1;
      } else if (item.variacion > -this.Modelformdata.rangoPorcentualEvaluar) {
        this.variacionMayorNegativo += 1;
      }
       if (item.variacionFechaFin < -this.Modelformdata.rangoPorcentualEvaluar) {
        this.variacionMenorFF += 1;
      }
    }
  }
 
  
  flattenArray(arrayOfArrays: any[]): any[] {
    return arrayOfArrays.flatMap(innerArray => innerArray);
  }

  filtrarPorCompania(array: any[], compania: any) {
    return array.filter(item => item.compania === compania);
  }

  selectRow(row: any) {
    this.filaSeleccionada = row;

  }

  OpenClasificacion() {
    const groupedData = this.groupVariationsByRange(this.arrayPositivos, this.clasificacionporcentual, 1);
        this.lvaData = new CdkTableVirtualScrollDataSource(groupedData);

const groupedDataN = this.groupVariationsByRange(this.arrayNegativos, this.clasificacionporcentual, -1);
        this.lvnData = new CdkTableVirtualScrollDataSource(groupedDataN);
        this.actualizarViewports();

    //const newcompania = JSON.parse(JSON.stringify(this.filaSeleccionada));
    /**const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.dialog.open(DialogClasificacionComponent, {
      width: '550px',
      height: '560px',
      panelClass: dialogClass,
      data: {
        optimaWallet: 'data',
        compania: 'newcompania',
        listaCompnia: 'locura'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
    });**/
  }

  OpenExclusion() {
    //const newcompania = JSON.parse(JSON.stringify(this.filaSeleccionada));
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.dialog.open(DialogExclusionComponent, {
      width: '950px',
      height: '460px',
      panelClass: dialogClass,
      data: {
        optimaWallet: 'data',
        compania: 'newcompania',
        listaCompnia: 'locura'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
    });
  }

  // Las tablas usan cdk-virtual-scroll-viewport, que mide su alto disponible al
  // momento de aparecer en el DOM. Cuando este componente vive dentro de una pestaña
  // que no está activa de entrada (como la nueva pestaña "Estadísticas" en
  // Planificador, a diferencia de Rastreador donde es la pestaña por defecto), el
  // viewport puede quedar con alto 0 y no repintar filas aunque el dataSource tenga
  // datos. Se fuerza un recálculo cada vez que cambian lvaData/lvnData (mismo patrón
  // que actualizarViewport() en estudio-earning.component.ts).
  actualizarViewports() {
    setTimeout(() => {
      this.viewportPositivos?.checkViewportSize();
      this.viewportNegativos?.checkViewportSize();
    });
  }

  ngOnDestroy(): void {
    this.subTema.unsubscribe();
    this.subLva?.unsubscribe();
    this.subLvn?.unsubscribe();
    this.subCompania?.unsubscribe();
  }

}
